"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExpiryDateMonthYear = void 0;
const getExpiryDateMonthYear = (expiryDateValue) => {
    const month = expiryDateValue === null || expiryDateValue === void 0 ? void 0 : expiryDateValue.split("/")[0];
    const year = expiryDateValue === null || expiryDateValue === void 0 ? void 0 : expiryDateValue.split("/")[1];
    return {
        month,
        year,
    };
};
exports.getExpiryDateMonthYear = getExpiryDateMonthYear;
